import React from 'react';
import { Box, Typography, Card, CardContent, Paper, Chip } from '@mui/material';
import { History } from '@mui/icons-material';

/**
 * Explicitly labels and renders a legacy (unstructured) transcript. Old
 * results are shown as plain text rather than manufacturing missing
 * speaker/timestamp information.
 */
const LegacyTranscript = ({ text }) => {
  if (!text) return null;

  return (
    <Card data-testid="legacy-transcript">
      <CardContent>
        <Box display="flex" alignItems="center" gap={1} mb={1}>
          <Typography variant="h6">Transcription</Typography>
          <Chip
            icon={<History fontSize="small" />}
            label="Legacy"
            size="small"
            variant="outlined"
            color="default"
            title="This transcript predates structured results and has no speaker/timestamp data."
          />
        </Box>
        <Paper elevation={1} sx={{ p: 2, backgroundColor: '#f9f9f9' }}>
          <Typography variant="body1" style={{ whiteSpace: 'pre-wrap' }}>
            {text}
          </Typography>
        </Paper>
      </CardContent>
    </Card>
  );
};

export default LegacyTranscript;